
import { Component, Vue } from 'vue-property-decorator';

import Form15ProcessHeader from "@/components/process/Form15/components/Form15ProcessHeader.vue";
import Form15StyleOfProceeding from "@/components/process/Form15/components/Form15StyleOfProceeding.vue";
import { form15StatusInfoType } from '@/types/Information/Form15';

@Component({
    components:{
        Form15ProcessHeader,        
        Form15StyleOfProceeding
    }
})
export default class FillForm15 extends Vue {

    stepsCompleted = {} as form15StatusInfoType;   

    mounted() {  
        this.stepsCompleted = {
            first: false,
            second: false,
            third: false
        }       
    }
}
